module.exports = __webpack_public_path__ + "static/media/benefits5.8a9fb95e.png";